import { get } from "lodash-es";

import { EHotelBrandsTypesId } from "@/hooks/useHotelBrandLogo";
/**
 * 获取酒店品牌logo
 * @param hotel
 * @returns
 */
export const getHotelBrandLogo = (hotel): string => {
  const brand = get(hotel, "_biz.charmdeerRawRender.shopBrand");
  if (!brand || brand._id === EHotelBrandsTypesId.others) {
    return "";
  }
  return brand?.imageDetail?.bannerLogo;
};
